import { useState, ChangeEvent, KeyboardEvent } from "react";
import { Row, Button, TextInput, IconButton } from "@narmi/design_system";

import { CaseQuery, PaymentQuery } from "./FilterDialog";
import type { TextQuery } from "./FedNowTransactionTable";

type CombinedQueryType = PaymentQuery | CaseQuery | TextQuery;

const SearchBar = ({
  submitCallback,
  setPage,
  filterQuery,
  setFilterQuery,
  setFilterDialogOpen,
}: {
  submitCallback: CallableFunction;
  setPage: CallableFunction;
  filterQuery: CombinedQueryType;
  setFilterQuery: CallableFunction;
  setFilterDialogOpen?: CallableFunction;
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  function handleSubmit() {
    const copy: CombinedQueryType = { ...filterQuery };
    if (searchTerm.length > 0) {
      copy.text = searchTerm;
      setFilterQuery(copy);
    }
    submitCallback(1, copy);
    setPage(1);
  }
  function handleClear() {
    (document.getElementById("search-input") as HTMLInputElement).value = "";
    const copy: CombinedQueryType = { ...filterQuery };
    copy.text = undefined;
    setFilterQuery(copy);
    submitCallback(1, copy);
    setPage(1);
    setSearchTerm("");
  }

  return (
    <div>
      <Row alignItems="center">
        <Row.Item>
          <TextInput
            id="search-input"
            endContent={
              setFilterDialogOpen ? (
                <IconButton name="filter-2" onClick={() => setFilterDialogOpen(true)} />
              ) : null
            }
            startContent={
              <>
                <span className="narmi-icon-search padding--right--xs" />
              </>
            }
            label={
              window.location.href.includes("cases")
                ? "Search for case ID or account number"
                : "Search for payment ID or account number"
            }
            showClearButton
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const val = e.target.value;
              if (!val || val === "") {
                handleClear();
              } else {
                setSearchTerm(val);
              }
            }}
            className="padding--right--s"
            onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Enter") {
                handleSubmit();
              }
            }}
          />
        </Row.Item>
        <Row.Item shrink>
          <Button
            label="Search"
            kind="secondary"
            onClick={() => {
              handleSubmit();
            }}
          />
        </Row.Item>
      </Row>
    </div>
  );
};

export default SearchBar;
